import { useState, useEffect } from 'react';
import { getAuthenticaSettings } from '@/lib/services/authentica';
import type { OTPMethod } from '@/lib/services/authentica';

export function useOTPMethod() {
  const [otpMethod, setOtpMethod] = useState<OTPMethod>('whatsapp');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        // getAuthenticaSettings() goes through the authenticaConfig callable
        // (server-side), never the raw Firestore doc — it already returns
        // null (and getOTPMethod() falls back to 'whatsapp') when Authentica
        // isn't configured, which is the same "SMS requires the provider
        // credential" fallback this hook used to compute locally before.
        const settings = await getAuthenticaSettings();
        setOtpMethod(settings?.otpMethod || 'whatsapp');
      } catch (e) {
        console.error('Error loading OTP method setting:', e);
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, []);

  return { otpMethod, loading };
}
